module.exports = __webpack_public_path__ + "static/media/lg-logo-check.3a43c4cd.svg";